<script>
import Talent from '../index';
export default {
  extends: Talent,
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    },
    handleClickTalent() {
      this.$windowOpen('/teacher/talent-show/rules');
    }
  }
};
</script>
